export default "__VITE_ASSET__OQ2C5RpS__"